import React from 'react';
import { DownloadIcon } from 'AppSrc/core/components/common/svg-icons';
import PropTypes from 'prop-types';
import { getAttachmentFileData } from 'AppSrc/core/work-info-items/work-info-item-queries';
// Package for downloading files to the browser https://www.npmjs.com/package/file-saver
import { saveAs } from 'file-saver';
// Package for transforming the server base64 data, to a Binary Long Object (Blob)
// https://www.npmjs.com/package/base64toblob
import base64ToBlob from 'b64-to-blob';

const DownloadAttachment = ({
  fileName,
  fileId,
  network,
  crqId,
}) => {
  const startDownload = () => {
    getAttachmentFileData({ crqId, fileId, network }).then(
      (base64Data) => {
        // DISPATCH HERE FREYJA
        const binaryData = base64ToBlob(base64Data);
        saveAs(binaryData, fileName);
      },
    );
  };
  return (
    <button
      type="button"
      className="download-attachment row-action"
      onClick={startDownload}
    >
      <div className="svg-wrapper">
        <DownloadIcon />
      </div>
    </button>
  );
};

DownloadAttachment.propTypes = {
  fileName: PropTypes.string,
  fileId: PropTypes.string,
  network: PropTypes.string,
  crqId: PropTypes.string,
};

export { DownloadAttachment };
